import { MapPin, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LangContext";
import type { BookingMode } from "@/data/certificateBookingActions";

type BookingModePickerProps = {
  modes: BookingMode[];
  onSelect: (mode: BookingMode) => void;
};

export const BookingModePicker = ({ modes, onSelect }: BookingModePickerProps) => {
  const { lang, t } = useLang();

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        {lang === "sv"
          ? "Hur vill du genomföra besöket? Välj digitalt videomöte eller besök på plats."
          : "How would you like to attend? Choose a digital video visit or an on-site appointment."}
      </p>
      <div className="grid gap-3 sm:grid-cols-2">
        {modes.includes("digital") ? (
          <Button
            type="button"
            variant="ghost-outline"
            size="xl"
            className="h-auto justify-start px-5 py-5 text-left"
            onClick={() => onSelect("digital")}
          >
            <Monitor className="mr-3 h-5 w-5 shrink-0 text-primary" />
            <span>
              <span className="block font-semibold text-foreground">{t.services.digital}</span>
              <span className="mt-1 block text-xs font-normal text-muted-foreground">
                {lang === "sv" ? "Videomöte online" : "Online video appointment"}
              </span>
            </span>
          </Button>
        ) : null}
        {modes.includes("onsite") ? (
          <Button
            type="button"
            variant="ghost-outline"
            size="xl"
            className="h-auto justify-start px-5 py-5 text-left"
            onClick={() => onSelect("onsite")}
          >
            <MapPin className="mr-3 h-5 w-5 shrink-0 text-primary" />
            <span>
              <span className="block font-semibold text-foreground">{t.services.onsite}</span>
              <span className="mt-1 block text-xs font-normal text-muted-foreground">
                {lang === "sv" ? "Mottagningen i Göteborg" : "Clinic in Gothenburg"}
              </span>
            </span>
          </Button>
        ) : null}
      </div>
    </div>
  );
};
